import React from 'react'
import ServiceData from './ServiceData'
import PagesMainSectionContent from '../Components/PagesMainSectionContent';
import "./Service.css"
import ColorBtn from '../Components/ColorBtn'


const ServiceContent = () => {

 
  return (
    <>
     <PagesMainSectionContent 
        MainSectionTitle="Our Product"
        MainSectionParagraph="Pick a collection of photo and then send them to us, we turn them into 50x50 magnets."
        />
      <div className="wrapper">
       
       
        {
          ServiceData.map((val, index) => {
            return (
              <>
                <div className="single-service" key={index}>
                  <div className="social">
                    <i className={val.cName} /></div>
                  <span />
                  <h3>
                    {val.title}</h3>
                  <p>
                    {val.desc}</p>
                    <ColorBtn btnName="Order now" colorBtnLink={val.url} />
                </div>


              </>
            )
          })
        }
    <div className="right-float-of-service-page">hey i am maham</div>
      </div>


    </>
  )
}

export default ServiceContent